export default class StickyHeader {

    static initializeEvents() {
        const header = document.querySelector('.header');
        const headerMobile = document.querySelector('.header-mobile');

        const stickyHeaderEventHandler = () => {
            const headerMobileHeight = headerMobile ? headerMobile.offsetHeight : 0;
            const guidedSearchMobile = document.querySelector('.guided-search-mobile');
            const main = document.querySelector('main');
            const background = document.querySelector('.ad-background');
            const menuSearch = document.querySelector('#menu-search');
            const menuButtons = header.querySelectorAll('.menu-button');

            const guidedSearchMobileHeight = guidedSearchMobile ? guidedSearchMobile.offsetHeight : 0;
            let top = String(232 + guidedSearchMobileHeight);

            const menu = document.getElementById('menu-main');
            const menuMHeight = menu ? menu.offsetHeight : 0;

            if (menu) {
                if (getComputedStyle(menu).getPropertyValue('display') === 'none') {
                    top = String(156 + guidedSearchMobileHeight);
                } else if (window.innerWidth >= 768 && window.innerWidth < 1248) {
                    top = String(211 + guidedSearchMobileHeight);
                }

                menu.style.position = '';
            }

            if (guidedSearchMobile) {
                guidedSearchMobile.style.top = headerMobileHeight + menuMHeight + 'px';

                if (window.scrollY >= header.offsetHeight && guidedSearchMobile.style.opacity === '') {
                    guidedSearchMobile.style.opacity = 1;
                    guidedSearchMobile.style.visibility = 'visible';
                    guidedSearchMobile.style.pointerEvents = 'unset';
                } else if (window.scrollY < header.offsetHeight && guidedSearchMobile.style.opacity === '1') {
                    guidedSearchMobile.style.opacity = '';
                    guidedSearchMobile.style.visibility = '';
                    guidedSearchMobile.style.pointerEvents = '';
                }
            }

            if (window.scrollY >= header.offsetHeight && headerMobile.style.opacity === '') {
                headerMobile.style.opacity = 1;
                headerMobile.style.visibility = 'visible';
                headerMobile.style.pointerEvents = 'unset';
                headerMobile.style.paddingTop = window.innerWidth >= 768 ? '' : '16px';
                headerMobile.style.paddingBottom = window.innerWidth >= 768 ? '' : '16px';

                menuButtons.forEach(button => {
                    button.style.position = 'fixed';
                    button.style.zIndex = '50';
                    button.style.top = '10px';
                });

                if (menu && window.innerWidth >= 768) {
                    menu.style.display = 'block';
                    menu.style.position = 'fixed';
                    menu.style.top = headerMobileHeight + 'px';
                    menu.style.width = '100%';
                }

            } else if (window.scrollY < header.offsetHeight && headerMobile.style.opacity === '1') {
                headerMobile.style.opacity = '';
                headerMobile.style.visibility = '';
                headerMobile.style.pointerEvents = '';
                headerMobile.style.paddingTop = '';
                headerMobile.style.paddingBottom = '';

                menuButtons.forEach(button => {
                    button.style.position = '';
                    button.style.zIndex = '50';
                    button.style.top = '';
                });

                if (menu && window.innerWidth >= 768) {
                    menu.style.position = '';
                    menu.style.top = '';
                    menu.style.width = '';
                }
            }

            if (menu && window.innerWidth < 768) {
                menu.style.display = '';
                menu.style.position = '';
                menu.style.top = '';
                menu.style.width = '';
            }

            if (window.innerWidth >= 768) {
                if (menuSearch) {
                    menuSearch.classList.remove('active');
                }

                if (menu && headerMobile.style.opacity === '1') {
                    menu.style.display = 'block';
                    menu.style.position = 'fixed';
                    menu.style.top = headerMobileHeight + 'px';
                    menu.style.width = '100%';
                }
            }

            if (main && background && document.body.classList.contains('with-ads')) {
                main.style.marginTop = (Math.min(0, window.scrollY - 120) * -1) + 'px';
                background.style.top = Math.max(-64, top - window.scrollY) + 'px';
            }
        };

        if (header && headerMobile) {
            stickyHeaderEventHandler();
            window.stickyHeaderEventHandler = stickyHeaderEventHandler;
            window.addEventListener('scroll', stickyHeaderEventHandler);
            window.addEventListener('resize', stickyHeaderEventHandler);
        }

        this.stickySummaryEventHandler();
    }

    static stickySummaryEventHandler = () => {
        const summaryBar = document.querySelector('.summary-sticky');

        if (!summaryBar) return;

        const btnToggle = document.querySelector('.summary-sticky .summary-toggle');
        const summaryBarElem = summaryBar.getBoundingClientRect();
        const summaryBottomPos = summaryBarElem.bottom;
        const summaryHeight = summaryBarElem.height;
        const popin = document.querySelector('.popin');

        summaryBar.classList.add('fixed');
        summaryBar.style.zIndex = "50";

        // Toggle de la flèche au click
        btnToggle.addEventListener('click', () => {
            const arrow = btnToggle.querySelector('i');
            if (arrow) {
                arrow.classList.toggle('ri-arrow-up-s-line');
                arrow.classList.toggle('ri-arrow-down-s-line');
            }
        })

        // Toggle du Summary Bar au Scroll + Gestion de la Popin
        const stickySummary = () => {
            const screenBottom = window.innerHeight + window.scrollY;
            summaryBar.classList.toggle('hidden', screenBottom >= (summaryBottomPos + (summaryHeight * 2)));
            if (popin) {
                popin.classList.toggle('hidden', window.innerWidth <= 768);
            }
        };

        stickySummary();
        window.addEventListener('scroll', stickySummary);
        window.addEventListener('resize', stickySummary);
    };
}